import eControllerTypes from '../eControllerTypes'
export default {
  ETSCT_HEADER: `${eControllerTypes.ECT_TOURNAMENTS_UPCOMING_SCREEN}__header`,
  ETSCT_BANNER: `${eControllerTypes.ECT_TOURNAMENTS_UPCOMING_SCREEN}__banner`,
  ETSCT_BONUS_DETAILS: `${eControllerTypes.ECT_TOURNAMENTS_UPCOMING_SCREEN}__bonus_details`,
  ETSCT_MODAL_BONUS_DETAILS: `${eControllerTypes.ECT_TOURNAMENTS_UPCOMING_SCREEN}__modal_bonus_details`,
}
